export default function getKDR(kills, deaths) {
    return (deaths !== 0 ? kills / deaths : kills).toFixed(2);
}